import * as React from "react";
const SvgFiRrFaceWeary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-weary_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M6.984 10.999c-.428 0-.841-.053-1.221-.146a1 1 0 1 1 .474-1.943c.453.111 2.009.358 2.971-1.102a1 1 0 1 1 1.67 1.1c-1.018 1.544-2.526 2.091-3.894 2.091m11.987-1.354a1 1 0 0 1-.735 1.208c-.38.093-.794.146-1.221.146-1.367 0-2.876-.545-3.894-2.09a1 1 0 1 1 1.67-1.1c.962 1.46 2.518 1.213 2.971 1.102a1 1 0 0 1 1.209.734m-1.13 6.814c.475.746-.188 1.706-1.052 1.517-1.117-.244-2.352-.975-4.793-.976-2.44 0-3.676.732-4.793.976-.864.189-1.527-.771-1.052-1.517 1.02-1.603 2.848-3.458 5.848-3.458s4.822 1.855 5.842 3.458"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-weary_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceWeary;
